// import { useState, useEffect, useRef } from "react";
// import "./quickhashing.css";
// import Table from "react-bootstrap/Table";
// import Axios from "axios";
// import Button from "react-bootstrap/Button";
// import swal from "sweetalert";
// import alertify from "alertifyjs";
// import "alertifyjs/build/css/alertify.min.css";

// function Quickhash() {
//   const [data2, setData2] = useState([]);
//   const [data, setData] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [barcode, setBarcode] = useState("");
//   const [enteredBarcodesList, setEnteredBarcodesList] = useState([]);
//   const [scannedBarcodes, setScannedBarcodes] = useState([]);
//   const barcodeInputRef = useRef(null);
//   const [selectedCheckboxCount, setSelectedCheckboxCount] = useState(0);
//   const [selectedDistributor, setSelectedDistributor] = useState(null);
//   const [isInputDisabled, setIsInputDisabled] = useState(false);
//   const [selectedItem, setSelectedItem] = useState(null);
//   const [data1, setData1] = useState([]);
//   const [dataa, setDataa] = useState([]);
//   const [titleFilter, setTitleFilter] = useState("");
//   const [filteredData, setFilteredData] = useState([]);

//   useEffect(() => {
//     Axios.get("http://13.200.156.92:5000/getshipment").then((response) => {
//       setData(response.data);
//     });

//     Axios.get("http://13.200.156.92:5000/getship").then((response) => {
//       const latestData = response.data.slice(0, 200);
//       // Map over the latest30Data to access each object's barcodeData
//       const allScannedData = latestData
//         .map((item) =>
//           item.barcodeData
//             // Map over each barcodeData to extract scannedData
//             .map((barcode) => barcode.scannedData)
//         )
//         .flat(2); // Flatten the array twice: first to flatten the outer map's result, then to flatten the scannedData arrays into a single array
//       // console.log(allScannedData);
//       setData2(allScannedData); // Store the flattened array of all scannedData strings
//     });
//   }, []);

//   useEffect(() => {
//     Axios.get("http://13.200.156.92:5000/getApproveDPO").then((response) => {
//       setData1(response.data);
//     });
//     Axios.get("http://13.200.156.92:5000/getship").then((response) => {
//       const latest30Data = response.data;
//       setDataa(latest30Data);
//     });
//   }, []);

//   const handleCheckboxChange = (orderIndex, itemIndex) => {
//     const updatedSelectedRows = [...selectedRows];
//     const foundIndex = updatedSelectedRows.findIndex(
//       (row) => row.orderIndex === orderIndex && row.itemIndex === itemIndex
//     );

//     if (foundIndex === -1) {
//       updatedSelectedRows.push({ orderIndex, itemIndex });
//       setSelectedCheckboxCount(selectedCheckboxCount + 1);
//     } else {
//       updatedSelectedRows.splice(foundIndex, 1);
//       setSelectedCheckboxCount(selectedCheckboxCount);
//     }

//     setSelectedRows(updatedSelectedRows);

//     if (selectedCheckboxCount === 1) {
//       window.location.reload();
//     }
//   };

//   const handleBarcodeScanned = async (scannedBarcode) => {
//     try {
//       // Call the API to get the key for the scannedBarcode
//       const response = await Axios.get(
//         `http://13.200.156.92:5000/getKey/${scannedBarcode}`
//       );
//       const key = response.data.key;
//       console.log(key);
//       // Check if the key is available
//       if (key) {
//         const selectedRow = selectedRows.find((row) =>
//           key.includes(data[row.orderIndex].updatedQuantity[row.itemIndex].sku)
//         );

//         const isBarcodeAlreadyEntered = enteredBarcodesList.includes(key);

//         if (isBarcodeAlreadyEntered) {
//           alertify.error("Barcode already exists in the list");
//           setBarcode("");
//           return;
//         }

//         const isBarcodeInDatabase = data2.includes(key);

//         if (isBarcodeInDatabase) {
//           alertify.error("Barcode already present in Database");
//           setBarcode("");
//           return;
//         }

//         if (selectedRow) {
//           const selectedItem =
//             data[selectedRow.orderIndex].updatedQuantity[selectedRow.itemIndex];

//           setSelectedItem(selectedItem);

//           // Your existing logic for handling barcode, now using the key
//           const skuExists = selectedRows.some((row) =>
//             key.includes(
//               data[row.orderIndex].updatedQuantity[row.itemIndex].sku
//             )
//           );

//           if (enteredBarcodesList.length === selectedItem.approvedquantity) {
//             alertify.alert("Quantity matched", "Stop scanning.").set({
//               onshow: function () {
//                 setIsInputDisabled(true);
//               },
//               onclose: function () {
//                 setIsInputDisabled(false);
//               },
//             });
//             setBarcode("");
//             return;
//           }

//           if (skuExists) {
//             setScannedBarcodes([
//               ...scannedBarcodes,
//               {
//                 enteredBarcode: key,
//                 // Add any additional properties you need
//               },
//             ]);

//             setBarcode("");
//             setEnteredBarcodesList([...enteredBarcodesList, key]);

//             if (
//               enteredBarcodesList.length ===
//               selectedItem.approvedquantity - 1
//             ) {
//               alertify.alert("Quantity matched", "Stop scanning.");
//               setBarcode("");
//               return;
//             }

//             alertify.success("Barcode scanned successfully");
//           } else {
//             alertify.error("SKU not found in the scanned barcode");
//             setBarcode("");
//           }
//         } else {
//           alertify.error("SKU not found in scanned barcode");
//           setBarcode("");
//         }
//       } else {
//         alertify.error("Key not found for the given value");
//         setBarcode("");
//       }
//     } catch (error) {
//       console.error("Error fetching key:", error);
//     }
//   };

//   // const handleManualBarcodeAddition = () => {
//   //   if (barcode.trim() !== "") {
//   //       handleBarcodeScanned(barcode);
//   //     alertify.error("Please enter a barcode");
//   //     setBarcode("");
//   //   }
//   // };

//   useEffect(() => {
//     if (barcodeInputRef.current) {
//       barcodeInputRef.current.focus();
//     }

//     const handleClickOutsideInput = (event) => {
//       if (
//         barcodeInputRef.current &&
//         !barcodeInputRef.current.contains(event.target)
//       ) {
//         barcodeInputRef.current.focus();
//       }
//     };

//     document.addEventListener("click", handleClickOutsideInput);

//     return () => {
//       document.removeEventListener("click", handleClickOutsideInput);
//     };
//   }, []);

//   function handleSubmit() {
//     if (enteredBarcodesList.length === 0) {
//       swal("Error", "Please add a barcode first", "error");
//       return;
//     }

//     if (enteredBarcodesList.length < selectedItem.approvedquantity) {
//       alertify.error("Scanned Qty is less than Approved Qty");
//       return;
//     }

//     const selectedShipmentIDsString = selectedRows
//       .map((row) => data[row.orderIndex].shipmentid)
//       .join(", ");

//     const selectedDistributorNamesString = selectedRows
//       .map((row) => data[row.orderIndex].distributorName)
//       .join(", ");

//     const orderNumbers = selectedRows
//       .map((row) => data[row.orderIndex].orderid)
//       .join(", ");
//     const batchIDs = selectedRows
//       .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].batchid)
//       .join(", ");
//     const titles = selectedRows
//       .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].title)
//       .join(", ");

//     const dataToSend = {
//       orderno: orderNumbers,
//       barcodeData: enteredBarcodesList,
//       count: enteredBarcodesList.length,
//       BatchID: batchIDs,
//       Title: titles,
//     };

//     console.log(dataToSend);
//     const postResult = Axios.post(
//       "http://13.200.156.92:5000/scanInbound",
//       dataToSend
//     );
//     console.log(postResult.data);

//     const shipmentDataToPost = {
//       totalCount: enteredBarcodesList.length,
//       totalBoxes: 1,
//       totalWeight: null,
//       barcodeData: {
//         BoxNo: 1,
//         scannedData: enteredBarcodesList,
//         count: enteredBarcodesList.length,
//         OrderNum: selectedShipmentIDsString,
//         DistributorName: selectedDistributorNamesString,
//       },
//     };
//     console.log(shipmentDataToPost);

//     const postResult1 = Axios.post(
//       "http://13.200.156.92:5000/createshipment",
//       shipmentDataToPost
//     );
//     console.log(postResult1.data);
//     swal({
//       title: "Outbound completed",
//       text: "",
//       icon: "success",
//     }).then(() => {
//       setTimeout(() => {
//         window.location.reload();
//       }, 1000);
//     });
//   }

//   const getUniqueFilteredDistributors = () => {
//     const filteredDistributors = data
//       .filter((order) => order.dispatchthrough === "Shivalik Enterprises")
//       .map((order) => order.distributorName);

//     const uniqueFilteredDistributors = [...new Set(filteredDistributors)];
//     return uniqueFilteredDistributors;
//   };

//   useEffect(() => {
//     // Filter data based on title
//     const filtered = data1.filter((row) => {
//       return (
//         row.dispatchthrough === "Shivalik Enterprises" &&
//         dataa.some((shipment) => {
//           return (
//             shipment.barcodeData?.[0]?.OrderNum === row.shipmentid ||
//             shipment.barcodeData?.[0]?.OrderNum === row.Dorderid
//           );
//         }) &&
//         row.updatedQuantity.some((quantityData) => {
//           return quantityData.title
//             .toLowerCase()
//             .includes(titleFilter.toLowerCase());
//         })
//       );
//     });
//     setFilteredData(filtered);
//   }, [data1, dataa, titleFilter]);

//   return (
//     <div className="outbound">
//       <h3>Quick Outbound</h3>

//       <div style={{ marginBottom: "1rem" }}>
//         <label>Select Distributor: </label>
//         <select
//           className=""
//           value={selectedDistributor || ""}
//           onChange={(e) => setSelectedDistributor(e.target.value || null)}
//         >
//           <option value="">All</option>
//           {getUniqueFilteredDistributors().map((distributor) => (
//             <option key={distributor} value={distributor}>
//               {distributor}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div className="mpcontainer">
//         <div className="mpcontent">
//           <Table className="outboundtable">
//             <thead>
//               <tr>
//                 <th>Order No</th>
//                 <th>Title</th>
//                 <th>Select</th>
//                 <th>Status</th>
//                 <th>Distributor Name</th>
//                 <th>PO Date</th>

//                 <th>Medium</th>
//                 <th>SKU</th>
//                 <th>Order Quantity</th>
//               </tr>
//             </thead>
//             <br />
//             <tbody>
//               {data.map((order, orderIndex) =>
//                 order.updatedQuantity.map((item, itemIndex) => {
//                   if (
//                     (!selectedDistributor ||
//                       order.distributorName === selectedDistributor) &&
//                     order.dispatchthrough === "Shivalik Enterprises"
//                   ) {
//                     return (
//                       <tr key={`${order.orderid}-${itemIndex}`}>
//                         {itemIndex === 0 && (
//                           <>
//                             <td rowSpan={order.updatedQuantity.length}>
//                               {order.shipmentid}
//                             </td>
//                             <td>{item.title}</td>

//                             <td>
//                               <input
//                                 type="checkbox"
//                                 onChange={() =>
//                                   handleCheckboxChange(orderIndex, itemIndex)
//                                 }
//                                 checked={selectedRows.some(
//                                   (row) =>
//                                     row.orderIndex === orderIndex &&
//                                     row.itemIndex === itemIndex
//                                 )}
//                                 disabled={filteredData.some(
//                                   (filteredItem) =>
//                                     filteredItem.shipmentid === order.shipmentid
//                                 )}
//                               />
//                             </td>

//                             <td>
//                               {filteredData.map((filteredItem, index) => {
//                                 if (
//                                   filteredItem.shipmentid === order.shipmentid
//                                 ) {
//                                   return (
//                                     <p
//                                       key={index}
//                                       style={{
//                                         color: "green",
//                                         fontWeight: "bold",
//                                       }}
//                                     >
//                                       Completed
//                                     </p>
//                                   );
//                                 }
//                                 return null;
//                               })}
//                             </td>

//                             <td rowSpan={order.updatedQuantity.length}>
//                               {order.distributorName}
//                             </td>
//                             <td rowSpan={order.updatedQuantity.length}>
//                               {order.ApprovalDate}
//                             </td>
//                           </>
//                         )}

//                         <td>{item.Medium}</td>
//                         <td>{item.sku}</td>
//                         <td>{item.approvedquantity}</td>
//                       </tr>
//                     );
//                   } else {
//                     return null;
//                   }
//                 })
//               )}
//             </tbody>
//           </Table>
//         </div>
//       </div>

//       <div className="selected-row-inputs">
//         {data.map((order, orderIndex) =>
//           order.updatedQuantity.map(
//             (item, itemIndex) =>
//               selectedRows.some(
//                 (row) =>
//                   row.orderIndex === orderIndex && row.itemIndex === itemIndex
//               ) && (
//                 <div
//                   style={{ marginTop: "2rem" }}
//                   key={`${orderIndex}-${itemIndex}`}
//                 >
//                   <p>Enter Barcode Manually:</p>
//                   <input
//                     type="text"
//                     ref={barcodeInputRef}
//                     value={barcode}
//                     onChange={(e) => setBarcode(e.target.value)}
//                     onKeyDown={(e) => {
//                       if (e.key === "Enter") {
//                         handleBarcodeScanned(barcode);
//                       }
//                     }}
//                     disabled={isInputDisabled}
//                   />
//                   {/* <button
//                     style={{ marginLeft: "1rem", padding: "4px" }}
//                     onClick={handleBarcodeScanned(barcode)}
//                     type="button"
//                     className="btn btn-primary"
//                   >
//                     Add Manually
//                   </button> */}
//                   <div>
//                     <h4 className="outboundcount">
//                       Entered Barcodes Count: {enteredBarcodesList.length}
//                     </h4>
//                     <h5>Entered Barcodes:</h5>
//                     <ul>
//                       {enteredBarcodesList.map((barcode, index) => (
//                         <li key={index}>{barcode}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               )
//           )
//         )}
//       </div>

//       <button
//         style={{ marginLeft: "22rem", marginBottom: "8rem" }}
//         type="button"
//         class="btn btn-primary"
//         onClick={handleSubmit}
//       >
//         {" "}
//         Save scanned ID
//       </button>
//     </div>
//   );
// }

// export default Quickhash;


import { useState, useEffect, useRef } from "react";
import "./quickhashing.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";
import swal from "sweetalert";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";

function Quickhash() {
  const [data2, setData2] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [enteredBarcodesList, setEnteredBarcodesList] = useState([]);
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const barcodeInputRef = useRef(null);
  const [selectedCheckboxCount, setSelectedCheckboxCount] = useState(0);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [data1, setData1] = useState([]);
  const [dataa, setDataa] = useState([]);
  const [titleFilter, setTitleFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [checkboxResponse, setCheckboxResponse] = useState("");

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getshipment").then((response) => {
      setData(response.data);
    });

    Axios.get("https://nodei.ssccglpinnacle.com/getship").then((response) => {
      const latestData = response.data.slice(0, 200);
      // Map over the latest30Data to access each object's barcodeData
      const allScannedData = latestData
        .map((item) =>
          item.barcodeData
            // Map over each barcodeData to extract scannedData
            .map((barcode) => barcode.scannedData)  ).flat(2);
      // console.log(allScannedData);
      setData2(allScannedData); // Store the flattened array of all scannedData strings
    });
  }, []);

  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getApproveDPO").then((response) => {
      setData1(response.data);
    });
    Axios.get("https://nodei.ssccglpinnacle.com/getship").then((response) => {
      const latest30Data = response.data;
      setDataa(latest30Data);
    });
  }, []);

  const handleCheckboxChange = async (orderIndex, itemIndex) => {
    const updatedSelectedRows = [...selectedRows];
    const foundIndex = updatedSelectedRows.findIndex(
      (row) => row.orderIndex === orderIndex && row.itemIndex === itemIndex
    );

    if (foundIndex === -1) {
      updatedSelectedRows.push({ orderIndex, itemIndex });
      setSelectedCheckboxCount(selectedCheckboxCount + 1);
    } else {
      updatedSelectedRows.splice(foundIndex, 1);
      setSelectedCheckboxCount(selectedCheckboxCount - 1);
    }

    setSelectedRows(updatedSelectedRows);

    // Only make the API call when the checkbox is checked
    if (foundIndex === -1) {
      try {
        const orderNum = data[orderIndex].shipmentid;
        const compareTo = data[orderIndex].updatedQuantity[itemIndex].approvedquantity;
        const response = await Axios.post("https://nodei.ssccglpinnacle.com/getTotalCount1", { orderNum, compareTo });
        setCheckboxResponse(response.data);
     
      } catch (error) {
        console.error("Error fetching checkbox response:", error);
      }
    } 
    // console.log(checkboxResponse);
    // else {
    //   setCheckboxResponse("");
    // }

    if (selectedCheckboxCount === 1) {
      window.location.reload();
    }
  };

  console.log(checkboxResponse);

  const handleBarcodeScanned = async (scannedBarcode) => {
    try {
      // Call the API to get the key for the scannedBarcode
      const response = await Axios.get(
        `https://nodei.ssccglpinnacle.com/getKey/${scannedBarcode}`
      );
      const key = response.data.key;
      console.log(key);
      // Check if the key is available
      if (key) {
        const selectedRow = selectedRows.find((row) =>
          key.includes(data[row.orderIndex].updatedQuantity[row.itemIndex].sku)
        );

        const isBarcodeAlreadyEntered = enteredBarcodesList.includes(key);

        if (isBarcodeAlreadyEntered) {
          alertify.error("Barcode already exists in the list");
          setBarcode("");
          return;  }

        const isBarcodeInDatabase = data2.includes(key);

        if (isBarcodeInDatabase) {
          alertify.error("Barcode already present in Database");
          setBarcode("");
          return;    }

        if (selectedRow) {
          const selectedItem =
            data[selectedRow.orderIndex].updatedQuantity[selectedRow.itemIndex];

          setSelectedItem(selectedItem);

          // Your existing logic for handling barcode, now using the key
          const skuExists = selectedRows.some((row) =>
            key.includes(
              data[row.orderIndex].updatedQuantity[row.itemIndex].sku   )   );

          if (skuExists) {
            setScannedBarcodes([
              ...scannedBarcodes,
              {
                enteredBarcode: key,
              },
            ]);

            setBarcode("");
            setEnteredBarcodesList([...enteredBarcodesList, key]);
            // if (
            //   enteredBarcodesList.length ===
            //   selectedItem.approvedquantity
            // )

      if (Number.isInteger(Number(checkboxResponse)) && enteredBarcodesList.length === Number(checkboxResponse)-1)
             {
              alertify.alert("Quantity matched", "Stop scanning.");
              setBarcode("");
              return;   }

            alertify.success("Barcode scanned successfully");
          } else {
            //To check for sku in order
            alertify.error("SKU not found in the scanned barcode");
            setBarcode("");
          }
        } else {
          //To check for sku in shelf
          alertify.error("SKU not found in scanned barcode");
          setBarcode("");
        }
      } else {
        alertify.error("Key not found for the given value");
        setBarcode("");
      }
    } catch (error) {
      console.error("Error fetching key:", error);
    }
  };

  useEffect(() => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
    }

    const handleClickOutsideInput = (event) => {
      if (
        barcodeInputRef.current &&
        !barcodeInputRef.current.contains(event.target)
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.addEventListener("click", handleClickOutsideInput);

    return () => {
      document.removeEventListener("click", handleClickOutsideInput);
    };
  }, []);

  function handleSubmit() {
    if (enteredBarcodesList.length === 0) {
      swal("Error", "Please add a barcode first", "error");
      return;
    }

    const selectedShipmentIDsString = selectedRows
      .map((row) => data[row.orderIndex].shipmentid)
      .join(", ");

    const selectedDistributorNamesString = selectedRows
      .map((row) => data[row.orderIndex].distributorName)
      .join(", ");

    const orderNumbers = selectedRows
      .map((row) => data[row.orderIndex].orderid)
      .join(", ");
    const batchIDs = selectedRows
      .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].batchid)
      .join(", ");
    const titles = selectedRows
      .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].title)
      .join(", ");

    const dataToSend = {
      orderno: orderNumbers,
      barcodeData: enteredBarcodesList,
      count: enteredBarcodesList.length,
      BatchID: batchIDs,
      Title: titles,
    };

    // console.log(dataToSend);
    const postResult = Axios.post(
      "https://nodei.ssccglpinnacle.com/scanInbound",
      dataToSend
    );
    console.log(postResult.data);

    const shipmentDataToPost = {
      totalCount: enteredBarcodesList.length,
      totalBoxes: 1,
      totalWeight: null,
      barcodeData: {
        BoxNo: 1,
        scannedData: enteredBarcodesList,
        count: enteredBarcodesList.length,
        OrderNum: selectedShipmentIDsString,
        DistributorName: selectedDistributorNamesString,
      },
    };
    console.log(shipmentDataToPost);

    const postResult1 = Axios.post(
      "https://nodei.ssccglpinnacle.com/createshipment",
      shipmentDataToPost
    );
    console.log(postResult1.data);
    swal({
      title: "Outbound completed",
      text: "",
      icon: "success",
    }).then(() => {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  }

  const getUniqueFilteredDistributors = () => {
    const filteredDistributors = data
      .filter((order) => order.dispatchthrough === "Shivalik Enterprises")
      .map((order) => order.distributorName);

    const uniqueFilteredDistributors = [...new Set(filteredDistributors)];
    return uniqueFilteredDistributors;
  };

  useEffect(() => {
    // Filter data based on title
    const filtered = data1.filter((row) => {
      return (
        row.dispatchthrough === "Shivalik Enterprises" &&
        dataa.some((shipment) => {
          return (
            shipment.barcodeData?.[0]?.OrderNum === row.shipmentid ||
            shipment.barcodeData?.[0]?.OrderNum === row.Dorderid
          );
        }) &&
        row.updatedQuantity.some((quantityData) => {
          return quantityData.title
            .toLowerCase()
            .includes(titleFilter.toLowerCase());
        })
      );
    });
    setFilteredData(filtered);
  }, [data1, dataa, titleFilter]);

  return (
    <div className="outbound">
      <h3>Quick Outbound</h3>
      <div style={{ marginBottom: "1rem" }}>
        <label>Select Distributor: </label>
        <select
          className=""
          value={selectedDistributor || ""}
          onChange={(e) => setSelectedDistributor(e.target.value || null)}       >
          <option value="">All</option>
          {getUniqueFilteredDistributors().map((distributor) => (
            <option key={distributor} value={distributor}>
              {distributor}
            </option>
          ))}
        </select>
      </div>
      <div className="mpcontainer">
        <div className="mpcontent">
          <Table className="outboundtable">
            <thead className="sticky-header">
               <tr>
                <th>Order No</th>
              <th>All Status</th>
                <th>Title</th>
                <th>Select</th>
                <th>Remaining</th>
                <th>Distributor Name</th>
                <th>PO Date</th>
                <th>Medium</th>
                <th>SKU</th>
                <th>Order Quantity</th>
              </tr>
            </thead>
            <br />
            <tbody>
              {data.map((order, orderIndex) =>
                order.updatedQuantity.map((item, itemIndex) => {
                  if (
                    (!selectedDistributor ||
                      order.distributorName === selectedDistributor) &&
                    order.dispatchthrough === "Shivalik Enterprises"
                  ) {
                    return (
                      <tr key={`${order.orderid}-${itemIndex}`}>
                        {itemIndex === 0 && (
                          <>
                            <td rowSpan={order.updatedQuantity.length}>
                              {order.shipmentid}
                            </td>
                                          <td>
                               {filteredData.map((filteredItem, index) => {
                                 if (
                                   filteredItem.shipmentid === order.shipmentid
                                 ) {
                                   return (
                                     <p   key={index}
                                       style={{
                                         color: "green",
                                         fontWeight: "bold",
                                       }}    >
                                       Completed  </p>
                                   );      }
                                 return null;
                              })}
                             </td>
                            <td>{item.title}</td>
                            <td>
                    <input
                      type="checkbox"
                      onChange={() => handleCheckboxChange(orderIndex, itemIndex)}
                      checked={selectedRows.some((row) =>
                        row.orderIndex === orderIndex &&
                        row.itemIndex === itemIndex
                      )}   
                      disabled={checkboxResponse === "Completed"}                  
                    />
                    {/* {checkboxResponse && selectedRows.some((row) =>
                      row.orderIndex === orderIndex && row.itemIndex === itemIndex
                    ) && (
                      <div>{checkboxResponse}</div>
                    )} */}
                  </td>
                  <td> {checkboxResponse && selectedRows.some((row) =>
                      row.orderIndex === orderIndex && row.itemIndex === itemIndex
                    ) && (
                      <div id="yupo">{checkboxResponse}</div>
                    )}</td>
                            <td rowSpan={order.updatedQuantity.length}>
                              {order.distributorName}
                            </td>
                            <td rowSpan={order.updatedQuantity.length}>
                              {order.ApprovalDate}
                            </td>
                          </>    )}
                        <td>{item.Medium}</td>
                        <td>{item.sku}</td>
                        <td>{item.approvedquantity}</td>
                      </tr>       );
                  } else {
                    return null;
                  }
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>
      <div className="selected-row-inputs">
        {data.map((order, orderIndex) =>
          order.updatedQuantity.map(
            (item, itemIndex) =>
              selectedRows.some(
                (row) =>
                  row.orderIndex === orderIndex && row.itemIndex === itemIndex
              ) && (
                <div
                  style={{ marginTop: "2rem" }}
                  key={`${orderIndex}-${itemIndex}`}     >
                  <p>Enter Barcode Manually:</p>
                  <input
                    type="text"
                    ref={barcodeInputRef}
                    value={barcode}
                    onChange={(e) => setBarcode(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        handleBarcodeScanned(barcode);
                      }
                    }}
                   />                
                  <div>
                    <h4 className="outboundcount">
                      Entered Barcodes Count: {enteredBarcodesList.length}
                    </h4>
                    <h5>Entered Barcodes:</h5>
                    <ul>
                      {enteredBarcodesList.map((barcode, index) => (
                        <li key={index}>{barcode}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )
          )
        )}
      </div>
      <button
        style={{ marginLeft: "22rem", marginBottom: "8rem" }}
        type="button"
        class="btn btn-primary"
        onClick={handleSubmit}   >
        {" "}
        Save scanned ID
      </button>
    </div>
  );}

export default Quickhash;

